import { render, staticRenderFns } from "./Index_Mobile.vue?vue&type=template&id=6b5b0cc5&scoped=true&"
import script from "./Index_Mobile.vue?vue&type=script&lang=js&"
export * from "./Index_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Index_Mobile.vue?vue&type=style&index=0&id=6b5b0cc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b0cc5",
  null
  
)

export default component.exports